import React, { ReactElement } from 'react';
import './Ticker-banner.less';
import { BLUE_BACKGROUND, WHITE_BACKGROUND } from '../../shared/constants/crmConstants';
const TickerBanner = ({
  bannerinfo,
  bannercss,
}: any): ReactElement => {

  const handleButtonClick = (link: string): any => {
    // Check if the link starts with 'http://' or 'https://'
    const url = (link?.startsWith('http://') || link?.startsWith('https://')) ? link : `http://${link}`;
    window?.open(url, '_blank');
  };

  return (
    <div className={`banner-container banner-background-color`} style={{
      backgroundColor: bannercss?.['tickerBackgroundColor']?.toLowerCase()
        === 'blue' ? BLUE_BACKGROUND : bannercss?.['tickerBackgroundColor'] === 'white' ? WHITE_BACKGROUND : bannercss?.['tickerBackgroundColor'],
      color: bannercss?.['tickerTextColor']?.toLowerCase()
        === 'blue' ? BLUE_BACKGROUND : bannercss?.['tickerTextColor'] === 'white' ? WHITE_BACKGROUND : bannercss?.['tickerTextColor'],
    }}>
      <div className="banner-carousel">
        {bannerinfo?.map((msg: any, index: any): any => (
          <React.Fragment key={msg.id}>
            {index > 0 && ' | '}{' '}
            {/* Render '|' separator if not the first message */}
            <div className={`banner-slide`}>
              <span>{msg?.message}</span>
              <span className={`cta-span`} onClick={(): any => handleButtonClick(msg?.link)}>
                {(msg?.cta?.toUpperCase())}
              </span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default TickerBanner;
